import React from 'react';

const NotFound: React.FC = () => {
  return (
    <div className="text-center">
      <h1>404 - Page Not Found</h1>
      <p>For support, please contact <a href="mailto:enquiry@ourjourney.uk">enquiry@ourjourney.uk</a></p>
    </div>
  );
};

export default NotFound;
